import React from "react";
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from 'react-bootstrap/Form'
import CustomInput from "../../../components/UI/Input/CustomInput";
import { Translation } from 'react-i18next';
import { Redirect } from "react-router-dom";
import BillingAddressSelect from "./BillingAddressSelect/BillingAddressSelect";
import { addressesService } from "../../ProfileContainer/ProfileAddresses/Service"
import Summary from "../Summary/Summary";
import toaster from "../../../utils/toaster";
import BillingAddressPopup from "../../ProfileContainer/ProfileAddresses/AddressPopup/BillingAddressPopup"
import { handleError } from "../../../utils/handleCatch";

export default class UserData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addresses: [],
    };
  }

  componentDidMount() {
    addressesService.getBillingAddresses()
      .then(response => {
        if (response.data.length > 0) {
          this.setState({
            addresses: response.data,
          })
        }
      }).catch((error) => {
        handleError(error)
        console.log(error);
      })
  }

  newAddress = (address) => {
    addressesService.newBillingAddress(address)
      .then(response => {
        this.setState({
          addresses: response.data,
        })
        toaster.standard("Indirizzo di fatturazione aggiunto con successo!")
      }).catch(error => {
        handleError(error)
        console.log(error);
      })
  }

  render() {
    const { timeSlotId, invoice, selectInvoice, cart, freeze, billingAddress,
      enableProductsReplacement, enableReplacement } = this.props;
    const { addresses } = this.state;

    if (!timeSlotId) {
      return <Redirect to='/checkout' />;
    }

    return (
      <Translation>
        {t =>
          <div className="checkout-data">
            <p className="signup-form-title">{t('signup.confirmData')}</p>
            <Row className="signup-row">
              <Col className="pb-3" md={6}>
                <CustomInput
                  label={"profileEmail"}
                  value={this.props.profileEmail}
                  onChange={this.props.selectProfileInfo}
                  type="email"
                />
              </Col>
              <Col className="pb-3" md={6}>
                <CustomInput
                  label={"profileMobilePhone"}
                  value={this.props.profileMobilePhone}
                  onChange={this.props.selectProfileInfo}
                  type="tel"
                />
              </Col>
            </Row>
            <Row className="signup-row">
              <Col className="pb-3" md={6}>
                <CustomInput
                  label={"profileFirstName"}
                  value={this.props.profileFirstName}
                  onChange={this.props.selectProfileInfo}
                  type="text"
                />
              </Col>
              <Col className="pb-3" md={6}>
                <CustomInput
                  label={"profileLastName"}
                  value={this.props.profileLastName}
                  onChange={this.props.selectProfileInfo}
                  type="text"
                />
              </Col>
            </Row>
            {cart && cart.deliveryMode === "AT_HOME" &&
              <Row className="signup-row">
                <Col className="pb-3">
                  <CustomInput
                    label="Indirizzo di consegna"
                    disabled={true}
                    value={cart && cart.delivery && cart.delivery.addressDescription}
                    type="email"
                  />
                </Col>
              </Row>
            }

            <hr />

            <p style={{ marginBottom: "20px" }} className="signup-form-title">Note per la consegna</p>

            <Form.Control
              as="textarea"
              name="notes"
              className="signup-textarea checkout-textarea w-100"
              rows="4"
              placeholder="Es. “Citofofonare al 202”, “Scala B - 3°piano”"
              onChange={this.props.selectProfileInfo}
              value={this.props.notes}
            />

            <hr />

            <div className="custom-control custom-checkbox">
              <input className="custom-control-input" type="checkbox" id="invoice" name="invoice"
                checked={invoice}
                onChange={selectInvoice}
              />
              <label style={{ marginBottom: "20px" }} className="custom-control-label" htmlFor="invoice">
                Desidero ricevere la fattura
              </label>
            </div>

            {invoice &&
              <>
                <div className="address-container">
                  <span style={{ marginBottom: "unset" }} className="signup-form-title">
                    Indirizzo di fatturazione
                  </span>
                  <BillingAddressPopup
                    action={this.newAddress}
                    title={t("addresses.new")}
                    button={t("save")}
                    isUpdate={false}
                    trigger={
                      <span className="add-link">Aggiungi indirizzo di fatturazione</span>
                    }
                  />
                </div>
                {addresses && addresses.map(address => (
                  <BillingAddressSelect
                    key={address.id}
                    address={address}
                    billingAddressId={this.props.billingAddressId}
                    selectAddress={this.props.selectAddress}
                  />
                ))}
              </>
            }

            <hr />

            <Summary
              cart={cart}
              freeze={freeze}
              timeSlotId={timeSlotId}
              billingAddress={billingAddress}
              enableProductsReplacement={enableProductsReplacement}
              enableReplacement={enableReplacement}
            />

          </div>
        }
      </Translation>
    );
  }
}
